import { Component, inject } from '@angular/core';
import { CustomerDetailService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CustomerDetailCreateDto,
  CustomerDetailDto,
  CustomerDetailExcelDownloadDto,
  CustomerDetailUpdateDto,
} from '../proxy/controlling/dtos/customer-detail';
import { CUSTOMERDETAIL_CONFIG, CUSTOMERDETAIL_FIELDS } from './customer-detail.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-customer-detail',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CustomerDetailService, ConfirmationService],
  templateUrl: './customer-detail.html',
  styleUrl: './customer-detail.scss',
})
export class CustomerDetail extends BaseCrudComponent<
  CustomerDetailDto,
  CustomerDetailCreateDto,
  CustomerDetailUpdateDto,
  CustomerDetailExcelDownloadDto
> {
  service = inject(CustomerDetailService);
  config = CUSTOMERDETAIL_CONFIG;
  fields = CUSTOMERDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: CustomerDetailDto): CustomerDetailUpdateDto {
    return {
      country: data.country,
      state: data.state,
      city: data.city,
      street: data.street,
      postCode: data.postCode,
      telephoneNumber: data.telephoneNumber,
      cellphoneNumber: data.cellphoneNumber,
      faxNumber: data.faxNumber,
      email: data.email,
      houseNumber: data.houseNumber,
      boxPostCode: data.boxPostCode,
      customerId: data.customerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CustomerDetail';
  }
}
